import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

export default function ProtectedAdminRoute({ children }) {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setStatus(user ? 'authed' : 'unauthed');
    });
    return unsub;
  }, []);

  if (status === 'loading') return <div style={{ padding: 40, textAlign: 'center' }}>Loading...</div>;
  if (status === 'unauthed') return <Navigate to="/admin/login" replace />;
  return children;
}
